
import { defineComponent, PropType } from 'vue'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import { AbstractTerminalViewService } from '@/views/dashboard/manage/port-manage/_components/abstract-terminal-view/abstract-terminal-view.service'
import { BlockViewDrawerService } from '@/views/dashboard/manage/port-manage/_components/block-view/_components/block-view-drawer.service'
import AbstractTerminalView from '@/views/dashboard/manage/port-manage/_components/abstract-terminal-view/abstarct-terminal-view.vue'
import { BlockPortItem } from '@/views/dashboard/manage/port-manage/_components/block-view/block-view.service'
import { http } from '@/common/basis/root-injector'

export default defineComponent({
  components: {
    AbstractTerminalView
  },
  props: {
    currentPort: {
      type: Object as PropType<BlockPortItem>,
      default: {} as PropType<BlockPortItem>
    }
  },
  emits: ['closePortTerminal'],
  setup (props, context) {
    const blockViewDrawerService = new BlockViewDrawerService(http)
    useReflectiveInjector([{
      provide: AbstractTerminalViewService as Type<AbstractTerminalViewService>,
      useValue: blockViewDrawerService,
    }])

    blockViewDrawerService.selectItem = (props.currentPort) as BlockPortItem

    return {
      closeDrawer () {
        context.emit('closePortTerminal')
      }
    }
  }
})
